export const BODY = [
  {
    name: 'Torva Platebody',
    slot: 'body',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -18, ranged: -14 },
      defence: { stab: 117, slash: 111, crush: 117, magic: -11, ranged: 142 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Justiciar Chestguard',
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -40, ranged: -20 },
      defence: { stab: 132, slash: 130, crush: 117, magic: -16, ranged: 142 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: 'Virtus Robe Top',
    slot: 'body',
    regions: ['Varlamore', 'Asgarnia', 'Fremennik', 'Desert'],
    requirements: [{ skill: 'Magic', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 35, ranged: -11 },
      defence: { stab: 47, slash: 36, crush: 56, magic: 31, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 2, prayer: 2 },
    },
  },
  {
    name: 'Masori Body (f)',
    slot: 'body',
    regions: ['Desert', 'Asgarnia'],
    requireAllRegions: true,
    requirements: [{ skill: 'Ranged', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -4, ranged: 43 },
      defence: { stab: 59, slash: 52, crush: 64, magic: 74, ranged: 60 },
      other:   { meleeStrength: 0, rangedStrength: 4, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Ancestral Robe Top',
    slot: 'body',
    regions: ['Kourend'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 35, ranged: -8 },
      defence: { stab: 42, slash: 31, crush: 51, magic: 28, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 3, prayer: 0 },
    },
  },
  {
    name: 'Bandos Chestplate',
    slot: 'body',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 65 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: -10 },
      defence: { stab: 98, slash: 93, crush: 105, magic: -6, ranged: 133 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: "Inquisitor's Hauberk",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: -3, slash: -3, crush: 12, magic: -11, ranged: -10 },
      defence: { stab: 67, slash: 55, crush: 71, magic: 0, ranged: 35 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: "Dharok's Platebody",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 115, slash: 112, crush: 106, magic: 0, ranged: 121 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon Chainbody',
    slot: 'body',
    regions: ['Kandarin', 'Wilderness'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 0 },
      defence: { stab: 81, slash: 93, crush: 98, magic: -3, ranged: 82 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon Platebody',
    slot: 'body',
    regions: [],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -30, ranged: -15 },
      defence: { stab: 109, slash: 107, crush: 97, magic: -6, ranged: 106 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Fighter Torso',
    slot: 'body',
    regions: [],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -40, ranged: 0 },
      defence: { stab: 62, slash: 85, crush: 62, magic: -10, ranged: 67 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Crystal Body',
    slot: 'body',
    regions: ['Tirannwn'],
    requirements: [{ skill: 'Ranged', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 40 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 60, ranged: 65 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Black D'hide Body",
    slot: 'body',
    regions: [],
    requirements: [{ skill: 'Ranged', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 30 },
      defence: { stab: 30, slash: 38, crush: 45, magic: 45, ranged: 50 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Elite Void Top',
    slot: 'body',
    regions: ['Asgarnia', 'Tirannwn', 'Kandarin'],
    requireAllRegions: true,
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 45, slash: 45, crush: 45, magic: 45, ranged: 45 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
    sets: ['elite_void_mage', 'elite_void_range', 'elite_void_melee'],
  },
  // ── Barrows bodies (Morytania) ─────────────────────────────────────────────
  {
    name: "Karil's Leathertop",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Ranged', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 30 },
      defence: { stab: 47, slash: 42, crush: 50, magic: 65, ranged: 57 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Ahrim's Robetop",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Magic', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 30, ranged: -10 },
      defence: { stab: 52, slash: 37, crush: 63, magic: 30, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: "Verac's Brassard",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 81, slash: 95, crush: 85, magic: 0, ranged: 81 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 5 },
    },
  },
  {
    name: "Torag's Platebody",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -30, ranged: -10 },
      defence: { stab: 122, slash: 120, crush: 107, magic: -6, ranged: 132 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Guthan's Platebody",
    slot: 'body',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -30, ranged: -10 },
      defence: { stab: 122, slash: 120, crush: 107, magic: -6, ranged: 132 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Other region bodies ────────────────────────────────────────────────────
  {
    name: 'Masori Body',
    slot: 'body',
    regions: ['Desert'],
    requirements: [{ skill: 'Ranged', level: 80 }, { skill: 'Defence', level: 30 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -4, ranged: 43 },
      defence: { stab: 37, slash: 35, crush: 38, magic: 25, ranged: 33 },
      other:   { meleeStrength: 0, rangedStrength: 4, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Granite Body',
    slot: 'body',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Strength', level: 50 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -22, ranged: -5 },
      defence: { stab: 87, slash: 84, crush: 79, magic: -6, ranged: 97 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Proselyte Hauberk',
    slot: 'body',
    regions: [],
    requirements: [{ skill: 'Defence', level: 30 }, { skill: 'Prayer', level: 20 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -30, ranged: -15 },
      defence: { stab: 65, slash: 63, crush: 55, magic: -6, ranged: 63 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 8 },
    },
  },
  {
    name: 'Infinity Top',
    slot: 'body',
    regions: [],
    requirements: [{ skill: 'Magic', level: 50 }, { skill: 'Defence', level: 25 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 22, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 22, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Blue Moon Chestplate',
    slot: 'body',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Magic', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 30, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 51, magic: 28, ranged: 0 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Blood Moon Chestplate',
    slot: 'body',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Strength', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: -10 },
      defence: { stab: 60, slash: 80, crush: 80, magic: 40, ranged: 79 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Eclipse Moon Chestplate',
    slot: 'body',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 31 },
      defence: { stab: 15, slash: 18, crush: 57, magic: 55, ranged: 32 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Hueycoatl Hide Body',
    slot: 'body',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 70 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 30 },
      defence: { stab: 55, slash: 47, crush: 60, magic: 56, ranged: 55 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Sunfire Fanatic Cuirass',
    slot: 'body',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -30, ranged: -15 },
      defence: { stab: 82, slash: 80, crush: 72, magic: -6, ranged: 80 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 10 },
    },
  },
  {
    name: "Oathplate chest",
    slot: 'body',
    regions: ['Kourend'],
    requirements: [{ skill: 'Defence', level: 78 }],
    bonuses: {
      attack:  { stab: 0, slash: 16, crush: 0, magic: -16, ranged: -18 },
      defence: { stab: 105, slash: 128, crush: 100, magic: -5, ranged: 112 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
